import '../../styles/globals.css'
import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import { Paper, Grid } from '@mui/material';

import MembershipTeaserImage1 from '../../images/homepage/sign-up-teaser1.png';

import { InlineIcon } from '@iconify/react';
import FlashPlayer from '../dashboard/adobeanimate/FlashPlayer';

import giveDirectlyLogo from '../../images/causes/icons/give-directly.png';
import evidenceActionLogo from '../../images/causes/icons/evidence-action.png';
import coolEarthLogo from '../../images/causes/icons/cool-earth.png';
import wildAnimalInitiativeLogo from '../../images/causes/icons/wild-animal-initiative.png';
import cleanAirTaskForceLogo from '../../images/causes/icons/clean-air-taskforce.png';
import msfLogo from '../../images/causes/icons/msf.png';
import { useTheme } from '@emotion/react';


function HeaderWelcome() {
    return (
        <Typography variant="body2" sx={{ marginTop: "1.5rem" }}>

        </Typography>
    );
}

function BackButton() {
    return (
        <Box>
            <p className={karmaStyles.homepageDescription}>
                <a href={"/karma"}>
                    back
                </a>
            </p>
        </Box>
    );
}

function HomepageAbout(props) {

    // access provider context for karma pool
    const karmaContext = useKarmaPoolContext();

    const [redirecting, setRedirecting] = useState(false);

    return (
        <>
            <Box className={karmaStyles.homepageBox} sx={{ paddingRight: "1rem", paddingLeft: "1rem" }}>
                <Box sx={{ width: "100%", justifyContent: "center", display: "flex", marginTop: "1.25rem" }}>
                    <FlashPlayer width={'320px'} height={'80px'} swfTarget={'karma_pool_intro2_2.swf'} />
                </Box>

                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "1.0rem" }}>
                    The Karma Pool is 100% dedicated to effective causes.
                </Typography>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>
                    We currently give £137.00 a month.
                </Typography>
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "0.75rem" }}>
                    Become a member to gain a democratic share in how we donate this money.
                </Typography>

                <Divider variant="middle" aria-hidden="true" sx={{ borderColor: 'rgba(221, 221, 221, 0.65)', margin: "0 auto", marginTop: "1.75rem", width: "14rem" }} />
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "1.75rem" }}>
                    Causes we support:
                </Typography>
                <CharitiesRowSection />
                {/* center the typography */}
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "0rem", marginTop: "1.25rem", width: "26rem" }}>
                        We're helping improve the lives of children in Sub-Saharan Africa through deworming initiatives, helping seriously impoverished people change their lives through direct giving, funding humanitarian aid in crisis zones and helping fight the climate crisis through research, direct CO2 reduction and habitat protection.
                    </Typography>
                </Box>
                <Divider variant="middle" aria-hidden="true" sx={{ borderColor: 'rgba(221, 221, 221, 0.65)', margin: "0 auto", marginTop: "1.75rem", width: "14rem" }} />
                <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem", marginBottom: "1rem", marginTop: "1.25rem" }}>
                    <a href={'/karma/register'} >
                        <u><strong>Want to get involved?</strong></u>
                    </a>
                </Typography>
                {/*<Box sx={{width: "100%", justifyContent: "center", display: "flex", marginTop: "1.0rem"}}>
                    <FlashPlayer width={'350px'} height={'170px'} swfTarget={'karma_pool_demo2.swf'}/>
                </Box> */}
            </Box>

            <Box sx={{ height: "1.375rem" }} />
            <BackButton />
            <Box sx={{ height: "1.375rem" }} />
        </>
    );
}

/* Render a row of all the charity icons */
function CharitiesRowSection(props) {
    let theme = useTheme();

    let isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    if (isMobile) {
        console.log("isMobile");
    }

    if (isMobile) {
        return (
            <CharitiesRowSectionMobile />
        );
    }

    return (
        <Box sx={{ justifyContent: "center", alignItems: "center", marginTop: "0.5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href={"https://www.doctorswithoutborders.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={msfLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.givedirectly.org/"} target="_blank" rel="noreferrer">
                    <img src={giveDirectlyLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.evidenceaction.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={evidenceActionLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.catf.us/"} target="_blank" rel="noopener noreferrer">
                    <img src={cleanAirTaskForceLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.coolearth.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={coolEarthLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://wildanimalinitiative.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={wildAnimalInitiativeLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
        </Box>
    );
}

function CharitiesRowSectionMobile(props) {
    return (
        <Box sx={{ justifyContent: "center", alignItems: "center", marginTop: "0.5rem" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href="https://www.doctorswithoutborders.org/" target="_blank" rel="noopener noreferrer">
                    <img src={msfLogo} alt="Doctors Without Borders Logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.givedirectly.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={giveDirectlyLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.evidenceaction.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={evidenceActionLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
            <Box sx={{ height: "0.75rem" }} />
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a href={"https://www.catf.us/"} target="_blank" rel="noopener noreferrer">
                    <img src={cleanAirTaskForceLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://www.coolearth.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={coolEarthLogo} alt="logo" width={40} height={40} />
                </a>
                <Box sx={{ width: "0.75rem" }} />
                <a href={"https://wildanimalinitiative.org/"} target="_blank" rel="noopener noreferrer">
                    <img src={wildAnimalInitiativeLogo} alt="logo" width={40} height={40} />
                </a>
            </Box>
        </Box>
    );
}

export default HomepageAbout;


